module.exports = __webpack_public_path__ + "static/IMG_5042-6bd06de0e3a824df23363c95615883d2.jpg";